import React, { useState, useEffect } from "react";
import { IonItem, IonSelect, IonSelectOption } from "@ionic/react";
import { useSelector, useDispatch } from "react-redux";
import { setActiveBranch, setScope } from "../features/auth/authSlice";
import SkeltonItemContent from "./formItems/SkeltonItemContent";
import { useIntl } from "react-intl";

const BranchSelect = () => {
  const [data, setData] = useState([]);
  const { profile, activeBranch } = useSelector((state) => state.auth);
  const { activeEmployee } = useSelector((state) => state.employee);
  const intl = useIntl();
  const dispatch = useDispatch();

  useEffect(() => {
    if (activeEmployee.active_branches) {
      setData([
        ...activeEmployee.active_branches,
        {
          name: intl.formatMessage({
            id: `app.mobile.all_branches`,
          }),
          id: null,
        },
      ]);
    }
  }, [activeEmployee, intl]);

  const onChange = (val) => {
    const scope = val ? `branches/${val}/` : ``;
    dispatch(setActiveBranch(val));
    dispatch(setScope(scope));
  };

  return !profile ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <div className="branch_selector">
      <IonSelect
        value={activeBranch}
        onIonChange={(e) => onChange(e.detail.value)}
        interface="action-sheet"
        cancelText={intl.formatMessage({
          id: "app.mobile.actions.cancel",
        })}
      >
        {data.map((option) => (
          <IonSelectOption key={option["id"]} value={option["id"]}>
            {option.name}
          </IonSelectOption>
        ))}
      </IonSelect>
    </div>
  );
};

export default BranchSelect;
